"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryByPhoneCode = exports.removeCountryCode = exports.formatPhoneNumber = exports.getPreferredCountry = exports.getPhoneCountries = exports.getParsedPhoneNumber = exports.getPreferredLanguageCode = exports.getCountryCodeA2 = exports.getCountryCode = exports.phoneIsValid = void 0;
const libphonenumber_js_1 = __importStar(require("libphonenumber-js"));
const examples_1 = __importDefault(require("libphonenumber-js/mobile/examples"));
const currency_1 = require("./currency");
const DEFAULT_ALLOWED_LANGUAGES = ['zh-HK', 'en-US', 'ja-JP', 'zh-TW', 'th-TH'];
const DEFAULT_LANGUAGE = 'zh-HK';
const DEFAULT_PHONE_COUNTRIES = [
    {
        code: '+852',
        label: '🇭🇰',
        maxLength: 8,
        a2: 'HK',
    },
    {
        code: '+886',
        label: '🇹🇼',
        maxLength: 9,
        a2: 'TW',
    },
    {
        code: '+66',
        label: '🇹🇭',
        maxLength: 9,
        a2: 'TH',
    },
];
function phoneIsValid(a2, phoneNumber) {
    var _a;
    // 首先尝试直接验证带区码的号码
    if ((0, libphonenumber_js_1.isValidPhoneNumber)(phoneNumber) && ((_a = (0, libphonenumber_js_1.default)(phoneNumber)) === null || _a === void 0 ? void 0 : _a.country) === a2) {
        return true;
    }
    // 如果不带区码，尝试加上指定国家的区码进行验证
    try {
        const parsedWithCountry = (0, libphonenumber_js_1.default)(phoneNumber, a2);
        return (parsedWithCountry === null || parsedWithCountry === void 0 ? void 0 : parsedWithCountry.isValid()) === true && parsedWithCountry.country === a2;
    }
    catch (error) {
        return false;
    }
}
exports.phoneIsValid = phoneIsValid;
function getCountryCode(config) {
    var _a;
    // First try to get from custom store function if provided
    if ((config === null || config === void 0 ? void 0 : config.getCountryFromStore) != null) {
        const storeCountry = config.getCountryFromStore();
        if (storeCountry != null) {
            return storeCountry;
        }
    }
    // Fallback to navigator language
    if (typeof navigator !== 'undefined' && ((typeof window !== 'undefined' && typeof window.document !== 'undefined') || (typeof navigator !== 'undefined' && navigator.product === 'ReactNative'))) {
        const lang = (_a = navigator.language) !== null && _a !== void 0 ? _a : navigator.userLanguage;
        if (lang != null) {
            return lang;
        }
    }
    return undefined;
}
exports.getCountryCode = getCountryCode;
// Currency to A2 country code mapping
const CURRENCY_TO_A2_MAP = {
    USD: 'US',
    HKD: 'HK',
    THB: 'TH',
    TWD: 'TW',
    CNY: 'CN',
    JPY: 'JP',
    SGD: 'SG',
    MYR: 'MY',
    IDR: 'ID',
    EUR: 'DE',
    GBP: 'GB',
    AUD: 'AU',
    CAD: 'CA',
    KRW: 'KR',
    VND: 'VN',
    PHP: 'PH',
};
/**
 * Get the country code (A2 format) from navigator language or custom store
 */
function getCountryCodeA2(config) {
    const country = getCountryCode(config);
    if (country == null) {
        return undefined;
    }
    // If country is in format like "zh-HK", extract the A2 code
    if (/[a-z]+-[A-Z]+/.test(country)) {
        // Extract A2 code from format like "zh-HK"
        const [, countryCode] = country.split('-');
        return countryCode;
    }
    // If country is already in A2 format, return it directly
    if (/^[A-Z]{2}$/.test(country)) {
        return country;
    }
    // If country looks like a currency code (3 uppercase letters), try to map it to A2
    if (/^[A-Z]{3}$/.test(country)) {
        const a2FromCurrency = CURRENCY_TO_A2_MAP[country];
        if (a2FromCurrency != null && a2FromCurrency !== '') {
            return a2FromCurrency;
        }
    }
    // If country is in a different format, return undefined
    return undefined;
}
exports.getCountryCodeA2 = getCountryCodeA2;
/**
 * Get the preferred language code based on country
 */
function getPreferredLanguageCode(config) {
    var _a, _b;
    const allowedLanguages = (_a = config === null || config === void 0 ? void 0 : config.allowedLanguages) !== null && _a !== void 0 ? _a : DEFAULT_ALLOWED_LANGUAGES;
    const defaultLanguage = (_b = config === null || config === void 0 ? void 0 : config.defaultLanguage) !== null && _b !== void 0 ? _b : DEFAULT_LANGUAGE;
    const countryCode = getCountryCodeA2(config);
    if (countryCode == null) {
        return defaultLanguage;
    }
    for (const allowedLang of allowedLanguages) {
        const [, a2] = allowedLang.split('-');
        if ((countryCode !== null && countryCode !== void 0 ? countryCode : '').toLowerCase() === (a2 !== null && a2 !== void 0 ? a2 : '').toLowerCase()) {
            return allowedLang;
        }
    }
    return defaultLanguage;
}
exports.getPreferredLanguageCode = getPreferredLanguageCode;
function getParsedPhoneNumber(countryCode, phoneNumber) {
    const parsed = (0, libphonenumber_js_1.default)(phoneNumber, countryCode);
    if (parsed == null || !parsed.isValid()) {
        return undefined;
    }
    return parsed.number;
}
exports.getParsedPhoneNumber = getParsedPhoneNumber;
/**
 * Get available phone countries
 */
function getPhoneCountries(config) {
    var _a;
    function getMaxLengthFromPattern(countryCode) {
        try {
            const lengths = [];
            // 獲取不同類型的示例號碼
            const mobileExample = (0, libphonenumber_js_1.getExampleNumber)(countryCode, examples_1.default);
            if (mobileExample !== null && mobileExample !== undefined) {
                // 獲取國內格式的號碼長度（可能包含前導 0）
                const nationalFormat = mobileExample.formatNational();
                const nationalDigits = nationalFormat.replace(/\D/g, ''); // 移除所有非數字字符
                lengths.push(nationalDigits.length);
                // 也考慮國際格式的 nationalNumber 長度
                lengths.push(mobileExample.nationalNumber.length);
            }
            // 返回最大長度，確保涵蓋所有可能的輸入格式
            return lengths.length > 0 ? Math.max(...lengths) : 0;
        }
        catch (error) {
            // do nothing if example number is not found
        }
        return 0;
    }
    const countries = (_a = config === null || config === void 0 ? void 0 : config.phoneCountries) !== null && _a !== void 0 ? _a : DEFAULT_PHONE_COUNTRIES.map(country => {
        var _a, _b;
        return Object.assign(Object.assign({}, country), { maxLength: (_b = (_a = getMaxLengthFromPattern(country.a2)) !== null && _a !== void 0 ? _a : country.maxLength) !== null && _b !== void 0 ? _b : 0 });
    });
    // 獲取當前用戶的國家代碼
    const preferredCountryCodeA2 = getCountryCodeA2(config);
    // 使用 sort 將匹配的國家排在最前面
    return countries.sort((a, b) => {
        if (preferredCountryCodeA2 != null && preferredCountryCodeA2 !== '') {
            const aIsPreferred = a.a2.toLowerCase() === preferredCountryCodeA2.toLowerCase();
            const bIsPreferred = b.a2.toLowerCase() === preferredCountryCodeA2.toLowerCase();
            if (aIsPreferred && !bIsPreferred)
                return -1;
            if (!aIsPreferred && bIsPreferred)
                return 1;
        }
        return 0; // 保持原有順序
    });
}
exports.getPhoneCountries = getPhoneCountries;
/**
 * Get the preferred country based on current location
 */
function getPreferredCountry(config) {
    var _a;
    const countries = getPhoneCountries(config);
    const countryCodeA2 = getCountryCodeA2(config);
    const selectedCountry = (_a = countries.find(c => c.a2 === countryCodeA2)) !== null && _a !== void 0 ? _a : countries[0];
    return selectedCountry;
}
exports.getPreferredCountry = getPreferredCountry;
/**
 * Format phone number with country code
 */
function formatPhoneNumber(phoneNumber, country) {
    // Remove any existing country code or formatting
    const cleanNumber = phoneNumber.replace(/^\+?\d{1,4}/, '').replace(/\D/g, '');
    // Add country code
    return `${country.code}${cleanNumber}`;
}
exports.formatPhoneNumber = formatPhoneNumber;
/**
 * Remove country code from phone number for display purposes
 * Uses libphonenumber-js to properly parse and format the phone number
 */
function removeCountryCode(phoneNumber) {
    if (phoneNumber === '' || phoneNumber == null) {
        return phoneNumber;
    }
    try {
        // Try to parse the phone number
        const parsed = (0, libphonenumber_js_1.default)(phoneNumber);
        // Return the national number (without country code) if parsing is successful
        if ((parsed === null || parsed === void 0 ? void 0 : parsed.isValid()) === true) {
            return parsed.formatNational().replace(/\D/g, ''); // Remove all non-digit characters
        }
    }
    catch (error) {
        // If parsing fails, fallback to manual removal for common formats
    }
    // Fallback: manually remove common country codes if parsing fails
    const commonCountryCodes = ['+852', '+886', '+66', '+1', '+86', '+81', '+65', '+60', '+62'];
    for (const code of commonCountryCodes) {
        if (phoneNumber.startsWith(code)) {
            return phoneNumber.slice(code.length);
        }
    }
    // If no country code found, return the original number
    return phoneNumber;
}
exports.removeCountryCode = removeCountryCode;
/**
 * Get country by phone code
 */
function getCountryByPhoneCode(phoneCode, config) {
    const countries = getPhoneCountries(config);
    const normalizedCode = phoneCode.startsWith('+') ? phoneCode : `+${phoneCode}`;
    return countries.find(country => country.code === normalizedCode);
}
exports.getCountryByPhoneCode = getCountryByPhoneCode;
/**
 * Create a locale helper with custom configuration
 */
function createLocaleHelper(config) {
    return {
        getCountryCodeA2: () => getCountryCodeA2(config),
        getPreferredLanguageCode: () => getPreferredLanguageCode(config),
        getPhoneCountries: () => getPhoneCountries(config),
        getPreferredCountry: () => getPreferredCountry(config),
        getCountryByPhoneCode: (phoneCode) => getCountryByPhoneCode(phoneCode, config),
        formatCurrency: (amount, configs, options) => {
            const countryCode = getCountryCodeA2(config);
            return (0, currency_1.formatCurrency)(amount, countryCode !== null && countryCode !== void 0 ? countryCode : 'HK', configs, options);
        },
        formatNumber: (amount, fractionDigits) => {
            const countryCode = getCountryCodeA2(config);
            return (0, currency_1.formatNumber)(amount, countryCode !== null && countryCode !== void 0 ? countryCode : 'HK', fractionDigits);
        },
        getCurrencySymbol: (options) => {
            const countryCode = getCountryCodeA2(config);
            return (0, currency_1.getCurrencySymbol)(countryCode !== null && countryCode !== void 0 ? countryCode : 'HK', options);
        },
        getCurrencyCode: () => {
            const countryCode = getCountryCodeA2(config);
            return (0, currency_1.getCurrencyCode)(countryCode);
        }
    };
}
exports.default = createLocaleHelper;
//# sourceMappingURL=locale.js.map